import { useQuery } from "react-query";
import { addressSuggestionsRepository } from "../address-suggestions.repository";

const queryKey = "address-suggestions";

export const useGetSuggestions = (query: string, enabled = true) => {
  const {
    data: suggestions = [],
    isLoading,
    error,
  } = useQuery({
    queryKey: [queryKey, query],
    queryFn: () => addressSuggestionsRepository.getSuggestions(query),
    enabled,
  });

  return {
    suggestions,
    isLoading,
    error,
  };
};
